/* src/app/modules/print-cards/components/cards/backgrounds/post-cards-4x6/true-north-portrait-card-stack-background/true-north-portrait-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 0.625rem;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
  border-radius: 0 0 1rem 1rem;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
:host .main-content ::ng-deep .image-with-color-overlay-and-opacity {
  border-radius: 0 0 1rem 1rem;
}
:host .card-header {
  background-color: #000000;
  height: 5.7%;
  width: 100%;
  border-radius: 1rem 1rem 0 0;
}
/*# sourceMappingURL=true-north-portrait-card-stack-background.component.css.map */
